import { ClearanceItemService } from '../clearance-item/clearance-item.service';
import { NgModule } from '@angular/core';
import { SearchComponent } from './search.component';
import { CommonModule } from '@angular/common';
import { SearchService } from './search.service';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../shared/core/auth.service';
// import { ClearanceItemBulkComponent } from '../clearance-item/bulk-action/clearance-item-bulk.component';
import { ClearanceItemGroupNameComponent } from '../clearance-item/clearance-item-groupname.component';
import { ClearanceItemBulkBarComponent } from '../clearance-item/bulk-action/clearance-item-bulkbar.component';
import { AssetManagerModule } from '../shared/asset-manager.module';
import { ClearanceItemBulkModule } from '../clearance-item/bulk-action/clearance-item-bulk.module';
import { ClearanceItemCommonModule } from '../clearance-item/clearance-item-common.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
@NgModule({
    declarations: [
        SearchComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        AssetManagerModule,
        ClearanceItemBulkModule,
        ClearanceItemCommonModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatCardModule
    ],
    providers: [
        SearchService, 
        // ClearanceItemService, 
        AuthService]
})
export class SearchModule {

}